import firebase from "firebase";
import Config from "../constants/config";
import { TemplatesBlocks, starterProperties } from "../constants/elements";
import _ from "lodash";
import { setBlocks, resetBlocks } from "../canvas/store";
import { initDB } from "../spreadsheet/store";
import { observable, action } from "mobx";
import startLiveTasks from "../scheduler/index";
import { setupListeners } from "../trigger/index";

var user = observable({
  id: false,
  scenes: false,
  name: "",
  currentScene: false,
  get listScenes() {
    return _.map(this.scenes, (v, k) => ({ id: k, label: v.canvas.label }));
  },
  get sceneBlocks() {
    return this.scenes[this.currentScene];
  }
});

firebase.initializeApp(Config.firebase);

export const getUserDatas = (userId, scene, live) => {
  firebase
    .database()
    .ref("/users/" + userId)
    .on("value", snap => {
      const val = snap.val();
      if (val) {
        user.scenes = val.scenes;
        user.currentScene = scene || val.currentScene;
        user.currentScene && setBlocks(user.sceneBlocks, live);
        user.currentScene && startLiveTasks(live, userId);
      }
    });
};

export const changeScene = s => {
  resetBlocks();
  firebase
    .database()
    .ref("/users/" + user.id + "/currentScene")
    .set(s);
};

export const createScene = (userId, blocks) => {
  const k = firebase
    .database()
    .ref("/users/" + userId + "/scenes")
    .push(blocks).key;
  firebase
    .database()
    .ref("/users/" + userId + "/currentScene")
    .set(k);
  return k;
};

export const createSceneCurrentUser = blocks => {
  createScene(user.id, blocks);
};

const mergeCustoms = (blocks, customs) => {
  return _.merge(blocks, customs);
};

export const createSceneFromTemplate = (tmplName, customs) => {
  createSceneCurrentUser(
    _.mapValues(mergeCustoms(TemplatesBlocks[tmplName], customs), block => {
      return { ...starterProperties(block.type), ...block };
    })
  );
};

export const deleteScene = (user, scene) => {
  firebase
    .database()
    .ref("/users/" + user + "/scenes/" + scene)
    .remove();
};

export const deleteCurrentScene = () => {
  deleteScene(user.id, user.currentScene);
  changeScene(Object.keys(user.scenes)[0]);
};

export const newScene = action("newScene", () => {
  user.currentScene = false;
  resetBlocks();
});

const doSyncBlocks = (userId, sceneId, blocks) => {
  firebase
    .database()
    .ref("/users/" + userId + "/scenes/" + sceneId)
    .set(blocks);
};

const trySyncBlocks = blocks => {
  if (user.id) {
    if (user.currentScene) {
      doSyncBlocks(user.id, user.currentScene, blocks);
    } else {
      createScene(user.id, blocks);
    }
  }
};

export const syncBlocks = _.debounce(trySyncBlocks, 250, {
  leading: false,
  trailing: true
});

export const init = (requestedUser, requestedScene, admin) => {
  if (requestedUser) {
    initDB(requestedUser);
    getUserDatas(requestedUser, requestedScene, true);
    setupListeners(requestedUser);
    if (admin) {
      user.id = requestedUser;
    }
  } else {
    firebase.auth().onAuthStateChanged(u => {
      if (u) {
        user.id = u.uid;
        user.twitchId = u.uid.split(":")[1];
        user.name = u.displayName;
        initDB(u.uid);
        getUserDatas(u.uid);
        setupListeners(u.uid);
      }
    });
  }
};

export const logout = () => {
  firebase
    .auth()
    .signOut()
    .then(() => {
      user.id = false;
      user.name = "";
      user.currentScene = false;
      resetBlocks();
    });
};

const liveURL = window.location.href + "live/";
export const exportControlledURL = () => liveURL + user.id;
export const exportUncontrolledURL = () => liveURL + user.id + "/" + user.currentScene;

export default user;



// WEBPACK FOOTER //
// ./src/user/index.js